<template>
  <div id="tcXlXiwVNCkjUgvt" class="logic_block">
    <div id="AbhfWih1Ex" class="block_tile">
      <p style="text-align:center;" textalign="center"><span class="font-size play-mode-fontSize-13"
          style="font-size: 18px"><span class="color_font"
            style="background-color:transparent;color:inherit;"><strong>“健康卡”使用规则</strong></span></span></p>
    </div>
    <div id="C2cOcDebu7" class="block_tile">
      <p style="text-align:right;" textalign="right"><br></p>
    </div>
    <div id="nf5ndKZdrv" class="block_tile">
      <p style="text-align:right;" textalign="right"> <span class="font-size play-mode-fontSize-9"
          style="font-size: 13px"><span class="color_font"
            style="background-color:transparent;color:inherit;">最新版本更新日期：2022<i class="otl-word-gap ProseMirror-widget"
              contenteditable="false"><span class=" "> </span></i>年<i class="otl-word-gap ProseMirror-widget"
              contenteditable="false"><span class=" "> </span></i>8<i class="otl-word-gap ProseMirror-widget"
              contenteditable="false"><span class=" "> </span></i>月<i class="otl-word-gap ProseMirror-widget"
              contenteditable="false"><span class=" "> </span></i>20<i class="otl-word-gap ProseMirror-widget"
              contenteditable="false"><span class=" "> </span></i>日</span></span></p>
    </div>
    <div id="vACB7TpDWT" class="block_tile">
      <p style="text-align:right;" textalign="right"><span class="font-size play-mode-fontSize-9"
          style="font-size: 13px"><span class="color_font"
            style="background-color:transparent;color:inherit;">最新版本生效日期：2022<i class="otl-word-gap ProseMirror-widget"
              contenteditable="false"><span class=" "> </span></i>年<i class="otl-word-gap ProseMirror-widget"
              contenteditable="false"><span class=" "> </span></i>9<i class="otl-word-gap ProseMirror-widget"
              contenteditable="false"><span class=" "> </span></i>月<i class="otl-word-gap ProseMirror-widget"
              contenteditable="false"><span class=" "> </span></i>1<i class="otl-word-gap ProseMirror-widget"
              contenteditable="false"><span class=" "> </span></i>日</span></span></p>
    </div>
    <div id="fn6vlyvLKh" class="block_tile">
      <p style="text-align:right;" textalign="right"><br></p>
    </div>
    <div id="I594VCYzbp" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font"
            style="background-color:transparent;color:inherit;">您在购买健康卡前，<strong>请您务必仔细阅读、充分理解各条款内容，特别是粗体下划线标识条款内容，您应重点阅读。</strong>当您购买健康卡，即表示您已充分阅读、理解并接受本须知的全部内容。如您有任何疑问，您可联系客服人员咨询。</span></span>
      </p>
    </div>
    <div id="CFd2sWDL47" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;"> </span></span></p>
    </div>
    <div id="j3ZMwP7d7f" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;"><strong>定义：</strong></span></span>
      </p>
    </div>
    <div id="RiAnvWjh0X" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;">一、 健康卡定义</span></span></p>
    </div>
    <div id="G2XHWCY7yu" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font"
            style="background-color:transparent;color:inherit;">“健康卡”指用户在约购“约健康”模块的资产账户，账户内的卡类型分为标准卡、平台赠卡，可在您启动氢原子设备时抵扣。标准卡是指您在平台购买的健康卡，平台赠卡是指约购平台免费赠送给您的健康卡。</span></span>
      </p>
    </div>
    <div id="lMiHAcNbjs" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;"> </span></span></p>
    </div>
    <div id="qmE90grzZZ" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;">二、 健康卡购买</span></span></p>
    </div>
    <div id="kdADdeEBNj" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;">1. 您可前往“约购<i
              class="otl-word-gap ProseMirror-widget" contenteditable="false"><span
                class=" "> </span></i>APP-约健康-优惠购卡”页面进行健康卡购买。健康卡购买后不可退款。<strong><u>同一用户针对购卡页面内“新用户专享”卡限买<i
                  class="otl-word-gap underline ProseMirror-widget" contenteditable="false"><span
                    class="  underline"> </span></i>1<i class="otl-word-gap underline ProseMirror-widget"
                  contenteditable="false"><span
                    class="  underline"> </span></i>次，健康卡类型如有调整，以页面提示为准。</u></strong></span></span></p>
    </div>
    <div id="yl2y23jkPd" class="block_tile">
      <p style="text-align:left;"><br></p>
    </div>
    <div id="KZeuyujXVi" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;">三、 健康卡有效期</span></span></p>
    </div>
    <div id="axPfEbcgVt" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;"><strong><u>健康卡自购买之日起<i
                  class="otl-word-gap underline ProseMirror-widget" contenteditable="false"><span
                    class="  underline"> </span></i>180<i class="otl-word-gap underline ProseMirror-widget"
                  contenteditable="false"><span
                    class="  underline"> </span></i>天内有效，不记名、不挂失。</u></strong></span><strong><u>标准卡有效期内可赠送他人使用。</u></strong></span>
      </p>
    </div>
    <div id="eug39t6TXv" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;"><strong><u>您可以通过“约购<i
                  class="otl-word-gap underline ProseMirror-widget" contenteditable="false"><span
                    class="  underline"> </span></i>APP-约健康-我的健康卡”，查看健康卡的具体有效期，逾期未使用即失效，请您在有效期内尽快使用。</u></strong></span></span>
      </p>
    </div>
    <div id="doaH7GsOFU" class="block_tile">
      <p style="text-align:left;"><br></p>
    </div>
    <div id="xIYsHS2HT6" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;">四、 个人信息使用说明</span></span></p>
    </div>
    <div id="wZ0luOXKGY" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;"><strong>1.
              为向您提供更便捷、更优质、个性化的产品或服务，努力提升您的体验，您同意我们向您提供附加服务的过程中可以收集及使用您的个人信息，我们将以短信、电话、推送通知及其他合理渠道联系您。请您注意，您可通过联系约购客服取消授权，我们将不再为您提供附加服务。</strong></span></span>
      </p>
    </div>
    <div id="AD7E68pyKz" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;"><strong>2.
              附加服务范围：包括余额未使用提醒、健康卡相关营促销活动提醒、亲友向您赠卡提醒。</strong> </span></span></p>
    </div>
    <div id="yVzTW7Vlb8" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;"> </span></span></p>
    </div>
    <div id="mO3cyyPrjM" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font"
            style="background-color:transparent;color:inherit;"><strong>“健康卡”使用与服务</strong></span></span></p>
    </div>
    <div id="LNk6N1uX0Y" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;">一、使用范围</span></span></p>
    </div>
    <div id="FUQpko4LCT" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font"
            style="background-color:transparent;color:inherit;"><strong><u>健康卡次数可在您启动氢原子设备时进行抵扣使用，仅支持健康门店的设备使用，具体以购卡详情页说明、订单结算页信息及相关活动页面规则为准。</u></strong></span></span>
      </p>
    </div>
    <div id="pVOYBymRJn" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;">健康卡当前<strong>仅支持手机端约购<i
                class="otl-word-gap ProseMirror-widget" contenteditable="false"><span class=" "> </span></i>APP<i
                class="otl-word-gap ProseMirror-widget" contenteditable="false"><span
                  class=" "> </span></i>中使用</strong>，暂不支持小程序及<i class="otl-word-gap ProseMirror-widget"
              contenteditable="false"><span class=" "> </span></i>PC<i class="otl-word-gap ProseMirror-widget"
              contenteditable="false"><span class=" "> </span></i>端的使用。</span></span></p>
    </div>
    <div id="TPlvTWvM50" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;">二、使用说明</span></span></p>
    </div>
    <div id="zH6HGuz5cB" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;">1. 您获得的健康卡次数都将累计进您的健康卡资产账户内，您可通过“约购<i
              class="otl-word-gap ProseMirror-widget" contenteditable="false"><span
                class=" "> </span></i>APP-约健康-我的健康卡”查看全部健康卡的次数，启动设备时默认<strong>多张健康卡中有效期短的优先抵用。</strong></span></span>
      </p>
    </div>
    <div id="KsUHqvHVSq" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;">三、关于开票</span></span></p>
    </div>
    <div id="aElEK2g34d" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;">1.
            购买健康卡，您可就实付金额部分申请开具增值税普通发票，可通过联系约购客服进行申请，开具发票需要额外补交税费。</span></span></p>
    </div>
    <div id="iwLlO4dQMF" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;">2.
            您在使用健康卡次数抵扣氢原子设备启动费时，健康卡将不再就您使用健康卡抵扣金额的部分另行开具发票。</span></span></p>
    </div>
    <div id="WhzJjCCCX1" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;">四、退卡规则</span></span></p>
    </div>
    <div id="bLF7YUcnpx" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;"><strong>1. <u>
                健康卡一经购买成功，即不支持退卡。</u></strong></span></span></p>
    </div>
    <div id="wzxoGzNKsA" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;">五、注意事项</span></span></p>
    </div>
    <div id="QUbEswQPV5" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;">1. 同一用户，是约购账户、收货人姓名、详细地址、联系方式、IP<i
              class="otl-word-gap ProseMirror-widget" contenteditable="false"><span
                class=" "> </span></i>地址等与用户身份相关信息，其中任意一项或数项存在相同、相似、通过特定标记形成批量信息、或其他非真实有效等情形的，均将被认定为同一用户。</span></span>
      </p>
    </div>
    <div id="YiuzzXpZGm" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;">2.
            在购买、使用健康卡过程中，如果您出现违规行为（包含但不限于盗刷、倒卖、批量机器作弊、批量注册、恶意购买套现、虚假交易等情形），约购平台将取消您购买、继续使用健康卡，并有权撤销违规交易，必要时将追究您的法律责任。</span></span>
      </p>
    </div>
    <div id="ytepzqkDcD" class="block_tile">
      <p style="text-align:left;"><span class="font-size play-mode-fontSize-9" style="font-size: 13px"><span
            class="color_font" style="background-color:transparent;color:inherit;">3.
            使用规则</span>以约购平台制定的定义及使用规则为准。因不可抗力情况，（如：因疫情、自然灾害、战争、政府、政策及司法机关行为等导致的不能预见、不能避免、不能克服的客观障碍）影响正常健康卡的使用，平台不承担责任。约购平台可根据实际情况，在法律允许范围内，对本规则进行变动或调整。</span>
      </p>
    </div>
    <div id="vzZe3ep4Z3" class="block_tile">
      <p style="text-align:left;"><br></p>
    </div>
  </div>
</template>

<script>

export default {
  
};
</script>

<style lang="scss" scoped>

.logic_block {
  padding: 0 10px;
}
</style>
